import { render } from "./CustomerTableControls.vue?vue&type=template&id=aabf6c20&scoped=true&lang=pug"
import script from "./CustomerTableControls.vue?vue&type=script&lang=js"
export * from "./CustomerTableControls.vue?vue&type=script&lang=js"

import "./CustomerTableControls.vue?vue&type=style&index=0&id=aabf6c20&lang=scss&scoped=true"
import "./CustomerTableControls.vue?vue&type=style&index=1&id=aabf6c20&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aabf6c20"]])

export default __exports__